import { useMemo } from "react";
import ILead from "../interfaces/ILead";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (leads: ILead[], shape: Shape | Shape[] | null): ILead[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? leads.filter(l => geometryService.isPointInsideShape(l.centerPoint, shape)) : leads, [leads, shape]);
}